/*
 * @Author: along longwang6@163.com
 * @Date: 2025-11-07 20:19:28
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-06-17 19:54:21
 * @FilePath: /ehr-web/src/components/TodoList/components/TodoItem/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { ReactNode } from 'react';
import styles from './index.module.less';
import { useNavigate } from 'react-router-dom';
import { TODO_PANEL_NAVIGATION_STATE } from '@/utils/todoPanelLayout';

interface IProps {
  avatar: ReactNode;
  title: string;
  content: ReactNode;
  tip?: string;
  url: string;
  onCancel?: () => void;
}

const TodoItem = React.memo((props: IProps) => {
  const { avatar, title, content, tip, url, onCancel } = props;
  const navigate = useNavigate();

  return (
    <div
      className={styles.todoItem}
      onClick={() => {
        onCancel?.();
        navigate(url, { state: TODO_PANEL_NAVIGATION_STATE });
        //  window.open(url, '_blank');
      }}
    >
      <div className={styles.avatarContainer}>{avatar}</div>

      <div className={styles.contentContainer}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{content}</div>
        {tip && <div className={styles.tip_v2}>{tip}</div>}
      </div>

      {/* <div className={styles.actionContainer}>
        <div className={styles.actionButton}>
          去处理 <IconRight />
        </div>
        
      </div> */}
    </div>
  );
});

export default TodoItem;
